import { useEffect, useState } from "react";
import {
  View,
  Text,
  Modal,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import { isMobile as useIsMobile } from "../util/commonFuncs";
import Colors from "../constant/Colors";
import { TempStore } from "../store/tempStore";
import { CommonStore } from "../store/commonStore";
import { UserStore } from "../store/userStore";

const COUNTDOWN_SECONDS = 3;

const PayFirstReminderModal = () => {
  const { width: windowWidth, height: windowHeight } = useWindowDimensions();
  const isMobile = useIsMobile();
  const showPayFirstReminder = TempStore.useState((s) => s.showPayFirstReminder);
  const pendingPayFirstReminderCheck = TempStore.useState((s) => s.pendingPayFirstReminderCheck);
  const showLoginPhoneModal = TempStore.useState((s) => s.showLoginPhoneModal);
  const selectedOutlet = CommonStore.useState((s) => s.selectedOutlet);
  const userName = UserStore.useState((s) => s.name);
  const userNumber = UserStore.useState((s) => s.number);

  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

  // Landing 关闭后 ShowGreetingPopupModal 会写 pending = 'guest' | 'member'
  // 这里等 selectedOutlet ready 再综合判断时机：
  //   - 'guest' / X：selectedOutlet ready 就直接 check config 弹 modal
  //   - 'member' + 已登入（!showLoginPhoneModal && userName && userNumber）：直接 check config 弹 modal
  //   - 'member' + LoginPhoneModal 打开了：清掉 pending，让登入成功后的 sessionStorage 路径接手（reload 后弹）
  useEffect(() => {
    if (!pendingPayFirstReminderCheck) return;
    if (!selectedOutlet || !selectedOutlet.uniqueId) return;

    if (pendingPayFirstReminderCheck === 'member') {
      if (showLoginPhoneModal) {
        TempStore.update((s) => {
          s.pendingPayFirstReminderCheck = null;
        });
        return;
      }
      if (!userName || !userNumber) return;
    }

    const enabled = selectedOutlet.PayFirstReminder === true;
    TempStore.update((s) => {
      s.pendingPayFirstReminderCheck = null;
      if (enabled) {
        s.showPayFirstReminder = true;
      }
    });
  }, [pendingPayFirstReminderCheck, selectedOutlet, showLoginPhoneModal, userName, userNumber]);

  // 一次性 mount effect：只会在页面 reload 后的 fresh mount 跑一次。
  // 用来消费 LoginPhoneModal 在 reload 前写入的 sessionStorage flag。
  useEffect(() => {
    try {
      const pending = window.sessionStorage.getItem('pendingPayFirstReminder');
      if (pending === '1') {
        window.sessionStorage.removeItem('pendingPayFirstReminder');
        TempStore.update((s) => {
          s.showPayFirstReminder = true;
        });
      }
    } catch (e) { }
  }, []);

  useEffect(() => {
    if (!showPayFirstReminder) {
      return;
    }

    setSecondsLeft(COUNTDOWN_SECONDS);

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [showPayFirstReminder]);

  if (!showPayFirstReminder) {
    return null;
  }

  const canConfirm = secondsLeft <= 0;

  return (
    <Modal visible={true} transparent={true} animationType="fade">
      <View
        style={{
          width: windowWidth,
          height: windowHeight,
          backgroundColor: Colors.modalBgColor,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <View
          style={{
            width: isMobile ? windowWidth * 0.85 : Math.min(windowWidth * 0.35, 480),
            backgroundColor: Colors.whiteColor,
            borderRadius: 12,
            paddingVertical: 28,
            paddingHorizontal: 24,
            alignItems: "center",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.25,
            shadowRadius: 6,
            elevation: 5,
          }}
        >
          <Text
            style={{
              fontFamily: "NunitoSans-Bold",
              fontSize: 20,
              color: Colors.mainTxtColor,
              textAlign: "center",
              marginBottom: 14,
            }}
          >
            {"Please Note"}
          </Text>

          <Text
            style={{
              fontFamily: "NunitoSans-SemiBold",
              fontSize: 15,
              color: Colors.mainTxtColor,
              textAlign: "center",
              lineHeight: 22,
              marginBottom: 22,
            }}
          >
            {
              "Your order will only be placed after payment is completed. Please pay during checkout or proceed to the counter to pay; otherwise the order will not be submitted."
            }
          </Text>

          <TouchableOpacity
            disabled={!canConfirm}
            onPress={() => {
              TempStore.update((s) => {
                s.showPayFirstReminder = false;
              });
            }}
            style={{
              backgroundColor: canConfirm ? Colors.primaryColor : Colors.fieldtBgColor,
              paddingVertical: 12,
              paddingHorizontal: 32,
              borderRadius: 8,
              alignItems: "center",
              justifyContent: "center",
              minWidth: 180,
            }}
          >
            <Text
              style={{
                fontFamily: "NunitoSans-Bold",
                fontSize: 16,
                color: canConfirm ? Colors.whiteColor : Colors.fieldtTxtColor,
              }}
            >
              {canConfirm
                ? "I Understand"
                : `I Understand (${secondsLeft}s)`}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

export default PayFirstReminderModal;
